import LargeBlueButton from '@components/common/button/LargeBlueButton';
import React, { useState } from 'react';
import ChecklistItem from './ChecklistItem';

interface BasicChecklistProps {
  onConfirm: () => Promise<void>;
  courseDataValid: boolean;
  filesAttached: boolean;
  accountInfoCompleted: boolean;
  attendedWorkshop: boolean;
}

const BasicChecklist: React.FC<BasicChecklistProps> = ({
  onConfirm,
  courseDataValid,
  filesAttached,
  accountInfoCompleted,
  attendedWorkshop,
}) => {
  const [confirmError, setConfirmError] = useState('');

  const confirm = () =>
    onConfirm()
      .then(() => setConfirmError(''))
      .catch((e: Error) => setConfirmError(e.message));

  return (
    <>
      <p className='mb-8'>
        In order to teach during the next session, please complete the steps in the following list:
      </p>
      <table className='w-full'>
        <thead>
          <tr className='bg-spanish-gray font-raleway text-lg'>
            <th className='pl-4 text-left font-normal'>Status</th>
            <th className='text-left font-normal'>Description</th>
          </tr>
        </thead>
        <tbody>
          <ChecklistItem
            done={courseDataValid}
            details={<p>Course Information (change below)</p>}
          />
          <ChecklistItem done={filesAttached} details={<p>Curriculum (attach to the right)</p>} />
          <ChecklistItem
            done={accountInfoCompleted}
            details={<p>Account Information (change in Instructor Services)</p>}
          />
          <ChecklistItem done={attendedWorkshop} details={<p>Attend Curriculum Workshop</p>} />
        </tbody>
      </table>
      <LargeBlueButton
        text='CONFIRM'
        onClick={confirm}
        className='mt-10'
        clickable={courseDataValid && filesAttached && accountInfoCompleted && attendedWorkshop}
      ></LargeBlueButton>
      <p className='text-red-600'>{confirmError}</p>
    </>
  );
};

export default BasicChecklist;
